import { render } from "./DriveCropper.vue?vue&type=template&id=a5783fd8&scoped=true&ts=true"
import script from "./DriveCropper.vue?vue&type=script&lang=ts"
export * from "./DriveCropper.vue?vue&type=script&lang=ts"

import "./DriveCropper.vue?vue&type=style&index=0&id=a5783fd8&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5783fd8"]])

export default __exports__